import { render, staticRenderFns } from "./PainelConfiguracaoUnidadeAdministrativaForm.vue?vue&type=template&id=e0c1d2e8"
import script from "./PainelConfiguracaoUnidadeAdministrativaForm.vue?vue&type=script&lang=js"
export * from "./PainelConfiguracaoUnidadeAdministrativaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports